import { Link } from "react-router-dom";
import { useRef, useState } from "react";
import Navbar from "../components/Navbar";
import ContactForm from "../components/ContactForm";
import LoginForm from "../components/LoginForm";
import "./LandingPage.css";
import "./auth/login-registro.css";
import redEmpleo from "../img/red_empleo.png";
import app from "../img/app.jpeg";
import appStore from "../img/appstore.png";
import googlePlay from "../img/googleplay.png";
import { useAuth } from "../context/AuthContext";
import AnonymousLandingPageContent from "../components/AnonymousLandingPageContent";
import ModalLayout from "../components/ModalLayout";
import LoginFormModal from "../components/LoginFormModal";
import useMediaQuery from "../hooks/unseMediaQuery";
import LegalMenu from "../components/navBar/LegalMenu";


const LandingPage = () => {
  const { user, isAuthenticated } = useAuth();
  const [showLoginForm, setShowLoginForm] = useState(false);
  const featuresRef = useRef();
  const resourcesRef = useRef();
  const downloadRef = useRef();

  /***********Video Modal Manage ************************/
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const openModal = () => setIsModalOpen(true);
  // const closeModal = () => setIsModalOpen(false);



  //Manejar ventana modal login
    const [modalOpen, setModalOpen] = useState(false);
      const isSmallDevice = useMediaQuery("(max-width:1023px)")

  const handleVideoModal = ()=>{
setIsModalOpen(prev => !prev)
  }

  const handleShowLoginForm = () => {
    setShowLoginForm(true);
  };

  const handleCloseLoginForm = () => {
    setShowLoginForm(false);
  };

  return (
    <>
      <Navbar
        onShowLoginForm={handleShowLoginForm}
        featuresRef={featuresRef}
        resourcesRef={resourcesRef}
        downloadRef={downloadRef}
        onHandleVideoModal={handleVideoModal}
        onHandleLoginModalOpen={() => setModalOpen(true)}
      />

      {showLoginForm && <LoginForm onClose={handleCloseLoginForm} />}

      <main className={`landing-page main-container-wrapper ${!isAuthenticated ? 'guest': ''}`}>
        {/* Textos principales */}
     
          <AnonymousLandingPageContent featuresRef={featuresRef} onHandleVideoModal={handleVideoModal} isModalOpen={isModalOpen} />

        {/* Mapa de recursos */}
        <section
          className="seccion-mapa mb-40 px-8 xl:px-0"
          id="map-section"
          ref={resourcesRef}
        >
          <h2>MAPA DE LOS RECURSOS LOCALES</h2>
          <iframe
            aria-label="Mapa de los recursos locales de Isla Cristina"
            src="https://www.google.com/maps/d/embed?mid=19F2_7tB9wlFmI6Yv7C-j_xkT2IBaErJ7&hl=es&ehbc=2E312F"
            width="100%"
            height="500"
          ></iframe>
        </section>

        {/* Promoción APP + formulario contacto */}
        <section
          className="app-contacto flex-center mb-50"
          ref={downloadRef}
          id="ad-section"
        >
          {/* Promoción APP */}
          <div className="promocion-app align-center w-50p">
            <img src={app} alt="Imagen de la aplicación movil" />
            <div className="promocion px-8 lg:px-0">
              <h2 className="texto mayusculas">
                Y AHORA TU{" "}
                <span className="verde">PASAPORTE HACIA EL EMPLEO</span> EN LA
                PALMA DE TU MANO
              </h2>
              <p className="descarga">Descargate la app</p>
              <div className="tiendas flex mt-5">
                <button className="no-border fondo-blanco">
                  <img src={appStore} alt="Enlace a App Store" />
                </button>
                <button className="no-border fondo-blanco">
                  <img src={googlePlay} alt="Enlace a Google Play" />
                </button>
              </div>
            </div>
          </div>

          {/* Formulario contacto */}
          <ContactForm />
        </section>

        {/* Enlaces legales */}
       <LegalMenu />
      </main>
{isSmallDevice && (
      <ModalLayout 
           isModalOpen={modalOpen}
           onClose={() => setModalOpen(false)}
      >
        <LoginFormModal onClose={() => setModalOpen(false)}/>  
      </ModalLayout>
)}
    </>
  );
};

export default LandingPage;
